import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import VaultCard from "./VaultCard";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowTrendUp, FaFlask } from "react-icons/fa6";

function chunkArray(arr, size) {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

const PAGINATION_MAX = 3;

const CardSlider = ({ tokens, cards }) => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [activeSlideIndex2, setActiveSlideIndex2] = useState(0);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [swiperInstance2, setSwiperInstance2] = useState(null);
  const navigate = useNavigate();

  const groupedCards = chunkArray(cards, 2);
  const groupedTokens = chunkArray(tokens, 2);

  const getPageCount = (arr) => {
    if (arr.length <= PAGINATION_MAX) return arr.length;
    return PAGINATION_MAX + 1;
  };

  return (
    <div className="exchange">
      <div className="slider-container">
        {/* Left Slider */}
        <div className="left-slider">
          <div className="top">
            <h2 id="topGainersHeading">
              <FaArrowTrendUp
                color="#a3e635"
                style={{ marginLeft: "8px", marginRight: "8px" }}
              />
              Top Gainers
            </h2>
          </div>
          <div className="bottom">
            {groupedCards.length === 0 ? (
              <p className="no-data-message">No data found</p>
            ) : (
              <>
                <Swiper
                  slidesPerView={3}
                  spaceBetween={30}
                  freeMode={true}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    320: { slidesPerView: 1, spaceBetween: 15 },
                    480: { slidesPerView: 1, spaceBetween: 15 },
                    768: { slidesPerView: 2, spaceBetween: 10 },
                    1080: { slidesPerView: 3, spaceBetween: 10 },
                  }}
                  onSwiper={setSwiperInstance}
                  onSlideChange={(swiper) =>
                    setActiveSlideIndex(swiper.realIndex)
                  }
                  className="mySwiper1"
                >
                  {groupedCards.map((group, i) => (
                    <SwiperSlide key={i}>
                      <div className="card-column">
                        {group.map((item, idx) => (
                          <VaultCard key={idx} item={item} />
                        ))}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                {/* Custom Pagination */}
                <div className="custom-pagination">
                  {Array.from({ length: getPageCount(groupedCards) }).map(
                    (_, idx) => {
                      if (
                        idx === PAGINATION_MAX &&
                        groupedCards.length > PAGINATION_MAX
                      ) {
                        return (
                          <span
                          // key="show-more"
                          // className="pagination-bullet show-more"
                          // onClick={() => navigate("/all-gainers")}
                          // style={{ cursor: "pointer" }}
                          >
                            ...
                          </span>
                        );
                      } else {
                        return (
                          <span
                            key={idx}
                            className={`pagination-bullet ${
                              activeSlideIndex === idx ? "active" : ""
                            }`}
                            onClick={() => {
                              if (swiperInstance) swiperInstance.slideTo(idx);
                            }}
                          ></span>
                        );
                      }
                    }
                  )}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Right Slider */}
        <div className="right-slider">
          <div className="top">
            <Link to="/detail-view">
              <h2>
                <FaFlask
                  color="#a3e635"
                  style={{ marginLeft: "8px", marginRight: "8px" }}
                />
                New Pools
              </h2>
            </Link>
          </div>
          <div className="bottom">
            {groupedTokens.length === 0 ? (
              <p className="no-data-message">No data found</p>
            ) : (
              <>
                <Swiper
                  slidesPerView={3}
                  spaceBetween={30}
                  freeMode={true}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    320: { slidesPerView: 1, spaceBetween: 15 },
                    480: { slidesPerView: 1, spaceBetween: 15 },
                    768: { slidesPerView: 2, spaceBetween: 10 },
                    1080: { slidesPerView: 3, spaceBetween: 10 },
                  }}
                  onSwiper={setSwiperInstance2}
                  onSlideChange={(swiper) =>
                    setActiveSlideIndex2(swiper.realIndex)
                  }
                  className="mySwiper2"
                >
                  {groupedTokens.map((group, i) => (
                    <SwiperSlide key={i}>
                      <div className="card-column">
                        {group.map((item, idx) => (
                          <VaultCard key={idx} item={item} />
                        ))}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                {/* Custom Pagination */}
                <div className="custom-pagination">
                  {Array.from({ length: getPageCount(groupedTokens) }).map(
                    (_, idx) => {
                      if (
                        idx === PAGINATION_MAX &&
                        groupedTokens.length > PAGINATION_MAX
                      ) {
                        return (
                          <span
                          // key="show-more"
                          // className="pagination-bullet show-more"
                          // onClick={() => navigate("/all-pools")}
                          // style={{ cursor: "pointer" }}
                          >
                            ...
                          </span>
                        );
                      } else {
                        return (
                          <span
                            key={idx}
                            className={`pagination-bullet ${
                              activeSlideIndex2 === idx ? "active" : ""
                            }`}
                            onClick={() => {
                              if (swiperInstance2) swiperInstance2.slideTo(idx);
                            }}
                          ></span>
                        );
                      }
                    }
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardSlider;
